import { render } from "./CreditReportNamibiaForm.vue?vue&type=template&id=74687ab3"
import script from "./CreditReportNamibiaForm.vue?vue&type=script&lang=js"
export * from "./CreditReportNamibiaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__